<template>
    <div class="seismic-safety-cards">
        <div class="container">
            <div class="desc-red"><p v-html="pageSetup.safety_quality.desc_red"></p></div>
            <div class="cards-items">
                <div class="item" v-for="item in pageSetup.safety_quality_cards">
                    <div class="item-img" :style="'background-image: url(' + item.img + ')'"></div>
                    <h3 v-html="item.title"></h3>
                    <p v-html="item.desc"></p>
                </div>
            </div>
            <div class="cards-after-desc">
                <h4 v-html="pageSetup.safety_quality_desc"></h4>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    // import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'seismic-safety-cards',
        components: {
            // svgIcon,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            pageSetup: 'loadSeismicSafetyPage',
        }),
        methods: {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/seismic-safety/seismic-safety-cards.scss';
    @import '@/styles/components/seismic-safety/respond/seismic-safety-cards-respond.scss';
    // @import '@/styles/components/about/respond/about-us-section-respond.scss';
</style>